var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-dropdown",class:{ open: _vm.open },attrs:{"tabindex":"-1"},on:{"focus":_vm.show,"focusout":_vm.hide}},[_vm._v(" "+_vm._s(_vm.user.name)+" "),_c('font-awesome-icon',{staticClass:"user-dropdown-icon",attrs:{"icon":"caret-down"}}),(_vm.open)?_c('ul',{staticClass:"user-dropdown-options"},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }